// ScrollToTop.js
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  const aboutRef = useRef(null);
  const contactRef = useRef(null);

  useEffect(() => {
    if (pathname === '/' && aboutRef.current) {
      aboutRef.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 600, behavior: "smooth" });
    }
  }, [pathname]);

  return (
    <>
      {/* Set refs for About and Contact sections */}
      <div ref={aboutRef} />
      <div ref={contactRef} />
    </>
  );
};

export default ScrollToTop;